import React from 'react'
import { Link} from "react-router-dom"
import BannerImage from '../assets/foodtable.jpg' 
import '../styles/Home.css'

function Home() {
  return (
    <div>
     <div className='home' style={{backgroundImage: `url(${BannerImage})` }}>
      <div className='headerContainer' >
        <h1> Rano's Ceylon Spice</h1>
        <br />
        <p>Spice it up, spice it right</p>
        <Link to='/menu'>
        <button>ORDER NOW</button>
        </Link>
        
      </div>
     </div>
    </div>
  )
}

export default Home
